export interface SelectOption<T = string> {
  value: T;
  label: string;
}

export enum NotificationType {
  ERROR = 'notificationError',
  WARNING = 'notificationWarning',
  SUCCESS = 'notificationSuccess',
}

export interface NotificationDataType {
  message: string
  type?: NotificationType
  close?: () => void
}